import ReactDOMServer from "react-dom/server";

const AWS = require("aws-sdk");
AWS.config.update({
	accessKeyId: "AKIAIL5WT6AVQWJWFSXQ",
	secretAccessKey: "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",
	region: "us-east-1",
});

export const sendEmailToProlitigio = (subject, html_message, onComplete, onError) => {
	const sendPromise = new AWS.SES({ apiVersion: "2010-12-01" })
		.sendEmail({
			Destination: {
				ToAddresses: ["prolitigio@gmail.com"],
			},
			Message: {
				Body: {
					Html: {
						Charset: "UTF-8",
						Data: `
						<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
						<html xmlns="http://www.w3.org/1999/xhtml">
						<head>
							<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
							<title>Correo Electronico Automatico de prolitigio.org</title>
							<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
							<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap-grid.min.css">
						</head>
						<body style="margin: 0; padding: 0;">
							<div class="container">${ReactDOMServer.renderToStaticMarkup(html_message)}</div>
						</body>
						</html>
						`,
					},
				},
				Subject: {
					Charset: "UTF-8",
					Data: subject,
				},
			},
			Source: "Contacto Prolitigio <contacto.prolitigio@gmail.com>",
			ReplyToAddresses: ["contacto.prolitigio@gmail.com"],
		})
		.promise();

	sendPromise
		.then(function (data) {
			onComplete(data.MessageId);
		})
		.catch(function (err) {
			onError(err);
		});
};
